import React from "react";

const PaginationFooter = ({ pagination, currentPage, loading, onPrev, onNext }) => {
  const pageSize   = pagination?.page_size || 20;
  const showingFrom = !pagination || pagination.count === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  const showingTo   = !pagination ? 0 : Math.min(currentPage * pageSize, pagination.count);

  const label = loading || !pagination
    ? "Loading..."
    : pagination.count === 0
    ? "No items"
    : `Showing ${showingFrom}–${showingTo} of ${pagination.count} invoices`;

  return (
    <div
      className="d-flex align-items-center justify-content-between px-4 py-3 mb-3 border-top bg-white rounded-bottom-3"
      style={{ background: "#f8f9fb" }}
    >
      <p className="small text-muted mb-0">{label}</p>
      <div className="d-flex gap-2">
        <button
          className="btn btn-sm btn-outline-secondary fw-bold"
          disabled={!pagination?.previous_page}
          onClick={onPrev}
        >
          Previous
        </button>
        <button
          className="btn btn-sm btn-outline-secondary fw-bold"
          disabled={!pagination?.next_page}
          onClick={onNext}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default PaginationFooter;
